import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { GoogleMapComponent } from './google-map/google-map.component';
import { environment } from '../../environments/environment';
import { BoatTrafficComponent } from './triffic-detail/boat-traffic.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'map-traffic',
  standalone: true,
  imports: [GoogleMapComponent, BoatTrafficComponent],
  styleUrl: '../../static/css/traffic.css',
  templateUrl: './map-traffic.component.html',
  encapsulation: ViewEncapsulation.None
})
export class MapTrafficComponent {
  name: string;
  type: string;
  stationId: string;
  branch: string;
  title: string;
  address: string;
  floor: string;
  capacity: string;
  village:string;
  lat: string;
  lng: string;
  state:string ="ALL"

  // [mapComponent] 子組件
  @ViewChild(GoogleMapComponent) mapComponent: GoogleMapComponent;
  constructor(private route:ActivatedRoute) {
  }
  defauts: string = "w";
  defautx: string = "";
  defauty: string = "";
  /**
  * ngOnInit[初始化後呼叫]
  */
  ngOnInit(){
    this.name = environment?.name
    this.route.paramMap.subscribe(params=>{
      var tmp=params.get("x");
      var tmp1=params.get("y");
      var tmps=params.get("s");
      if(tmp!=null&&tmp!=""){
        this.defautx=String(tmp);
        this.defauty=String(tmp1);
      }
      if(tmps!=null&&tmps!=""){
        this.defauts=String(tmps);
        
      }
      
      
    });
  }

  /**
  * ngAfter[視圖加載後自動呼叫]
  * (Action) 呼叫 [mapComponent] 底下的 getLocal()
  */
  ngAfterViewInit() {
    if(this.defautx!=""){
      
      this.mapComponent.changecenter(Number(this.defautx),Number(this.defauty));

    }
    else{
      
      if(this.defauts=="A"||this.defauts=="a"){
        this.mapComponent.getLocalsendToNativenew();

      }
      else{
        this.mapComponent.getLocal();
      }
      
    }
    
    
  }


  /**
  * function
  * (Action) 呼叫 [mapComponent] 底下的 getLocal()
  */
  callMap_getLocal() {
    if(this.defauts=="A"||this.defauts=="a"){
      
      this.mapComponent.getLocalsendToNativenew();

    }
    else{
      this.mapComponent.getLocal();
    }
    
  }


  showMarker(state:string){
    this.state = state;
    this.mapComponent.type = state;
  }


  showDetail(type:string,name:string,stationId:string,branch:string,title:string,address:string,floor:string,capacity:string,village:string,lat:string,lng:string){

    this.name = name;
    this.stationId = stationId;
    this.type = type;
    this.branch = branch;
    this.address=address;
    this.floor=floor;
    this.capacity=capacity;
    this.title = title;
    this.village=village;
    this.lat=lat;
    this.lng=lng;
    this.mapComponent.changecenter(Number(lat),Number(lng));
    
  }

 
  
  close(){
    this.type = "close";
    this.name = "";
    this.type = "";
    this.stationId = "";
    this.branch = "";
    this.address="";
    this.title = "";
    this.floor="";
    this.capacity="";
    this.village="";
    this.lat="";
    this.lat="";
    this.lng="";
  }


 
}
